<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong  v-if="doc_status!=0">{{$t('factor')}}</strong>
                <strong v-else>{{$t('request_order')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="doc_status==0" @click="finalize()" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{$t('savePrint')}}
                </CButton>

                <CButton v-if="doc_status==0" @click="goEdit()" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('buttons.edit') }}
                </CButton>

                <CButton v-if="doc_status==0" @click="delete_item_dialog()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.delete') }}
                </CButton>
                <CButton @click="print()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.print') }}
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCard id="printMe">
            <CCardHeader>
              <CRow>

                <CCol sm="4" md="4" style="text-align: right">
<!--                  <strong style="text-align: right;top: 35%;position: absolute;">{{ selectedTypeTitle }}-->
<!--                    {{ $t('components.number') }}: {{ doc_id }}</strong>-->
     <strong v-if="doc_status!=0" style="text-align: right;top: 35%;position: absolute;">
                    {{ $t('factor_no') }}: {{ doc_id_no }}</strong>

      <strong v-else style="text-align: right;top: 35%;position: absolute;">
                    {{ $t('request_order_no') }}: {{ doc_id_no }}</strong>

                </CCol>
                <CCol sm="4" md="4">
                  <h2>{{ VUE_APP_NAME }}</h2>

                </CCol>
                <CCol sm="4" md="4" style="text-align: left">
                  <CImg :src="get_logo()" width="100px" height="50px"/>

                </CCol>
              </CRow>

            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="4" md="4">
                  <strong>{{ selectedTypeLabel }} : {{ document_person }}</strong>

                </CCol>
                <CCol sm="4" md="4" class="text-center">
<!--                  <strong>{{ selectedTypeLabelRevert }} : {{ this.$root.company_name }}</strong>-->
                  <strong>{{ $t('components.warehouse') }}: {{ selected_place }}</strong>

                </CCol>

                <CCol sm="4" md="4" class="text-left">
                  <strong>{{ $t('creator') }} : {{ document_visitor }} {{ vMobile }}</strong>

                </CCol>
              </CRow>
              <hr class="mt-0">

              <CRow>

                <CCol sm="4" md="4">
                  <div>
                    <strong>{{ $t('components.date') }} : {{ get_date(date) }}</strong>
                  </div>
                </CCol>

                <CCol sm="4" md="4" class="text-center">

                </CCol>

                <CCol sm="4" md="4" class="text-left">
<!--                  <strong>{{ $t('components.driver') }}: {{ document_driver }} {{ tozikonandeMobile }}</strong>-->

                </CCol>
              </CRow>
              <hr class="mt-0">

              <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary }} </p>
              <hr v-if="document_summary!=null" class="mt-0">

              <CCardHeader style="text-align: right">
                <strong>{{ $t('components.documentProducts') }}</strong>
              </CCardHeader>


              <CDataTable
                  :items="product_items"
                  :fields="fields"
                  striped
                  border
                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item}">

                    <td style="text-align: center">
                    <strong >{{ item.row_id + 1 }}</strong>

                  </td>

                </template>
                <template #name="{item}">

                  <td>
                    <strong >{{ item.productName }}</strong>

                  </td>

                </template>

                <template #unit="{item}">

                  <td>
                    <strong >{{ item.productUnitName }}</strong>

                  </td>

                </template>

                <template #qty="{item}">

                  <td>
                    <strong >{{ Math.abs(item.qty) }}</strong>

                  </td>

                </template>
                <template #price="{item}">

                  <td>
                    <strong style="float: right"  >{{get_currency(item.price) }} </strong>

                  </td>

                </template>
                <template #totalPrice="{item}">

                  <td>
                    <strong style="float: right"  >{{get_currency(item.totalPrice) }} </strong>

                  </td>

                </template>
                <template #takhfif="{item}">

                  <td>
                    <strong style="float: right"  >{{
                        get_currency( item.takhfif)
                      }} </strong>

                  </td>

                </template>
                <template #tax="{item}">

                  <td>
                    <strong style="float: right"  >{{
                        get_currency(item.tax)
                      }} </strong>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <strong >{{ item.docDesc }}</strong>

                  </td>

                </template>


              </CDataTable>
              <CRow >
                <CCol col="4"></CCol>
                <CCol col="4"></CCol>
                <CCol col="4">
                  <CDataTable
                      :items="document_result_price"
                      :fields="fields_total_price"
                      striped
                      border
                      :responsive="false"
                      :items-per-page="200"
                      hover
                      pagination
                  >
                    <template #resultTitle="{item}">

                      <td>
                        <strong >{{ item.resultTitle }}</strong>

                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td>
                        <strong >{{ item.resultPrice }}</strong>
                        <strong > {{VUE_APP_Currency}}</strong>

                      </td>

                    </template>

                  </CDataTable>

                </CCol>
              </CRow>


            </CCardBody>
            <CCardFooter class="text-right">

              <hr class="mt-0">

              <h4 dir="rtl" v-if="address!= 'undefined'">{{ $t('components.address') }} : {{ address }}</h4>


            </CCardFooter>
          </CCard>

      </CCol>
    </CRow>
    <CModal
        :title="$t('documentDoc')"
        color="dark"
        size="lg"
        :show.sync="pre_finalize"
    >
      <CRow>
        <CCol col="4"><label>{{$t('docNumber')}}: 1</label></CCol>
        <CCol col="4"><label>{{$t('documentDoc')}}</label></CCol>
        <CCol col="4"><label>{{$t('docDate')}}</label></CCol>
      </CRow>
      <CRow>
        <CCol col="4"><label>{{$t('docDescription')}}:</label></CCol>
        <CCol col="4"><label></label></CCol>
        <CCol col="4"><label>Page 1</label></CCol>
      </CRow>
      <CDataTable
          :items="pre_finalize_items"
          :fields="pre_finalize_fields"
          striped
          border
          :items-per-page="200"
          hover
          pagination
      >

        <template #under-table>
          <label></label>
          <br>
          <label>{{$t('tanzimKonande')}}</label>
        </template>
      </CDataTable>

      <template #footer>
        <CButton @click="pre_finalize = false,finalize()" color="danger">{{$t('buttons.ok')}}</CButton>
        <CButton @click="pre_finalize = false" color="danger">{{$t('buttons.cancel')}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      pre_finalize:false,
      doc_id :'',
      doc_id_no :'',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('tables.name'), _style: 'padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('tables.price'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.totalPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],


      pre_finalize_items: [{
        tafzili:"9",
        moein:"8",
        kol:"12",
        account:"پرداخت هزینه سوخت",
        price_joz:"120000",

        price_bedehkar:"1000",
        price_bestankar:"1000"},{
        tafzili:"",
        moein:"",
        kol:"",
        account:"",
        price_joz:this.$t('totalDoc'),
        price_bedehkar:"1000",
        price_bestankar:"1000"}],
      pre_finalize_fields: [
        {key: 'tafzili', label: this.$t('tafsili'), _style: 'width:3%;padding:0px'},
        {key: 'moein', label: this.$t('moein'), _style: 'width:3%;padding:0px'},
        {key: 'kol', label: this.$t('total'), _style: 'width:3%;padding:0px'},
        {key: 'account', label: this.$t('components.groupName'), _style: 'width:10%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price_joz', label: this.$t('subAmount'), _style: 'width:5%;padding:0px'},
        {key: 'price_bedehkar', label: this.$t('bedehkar'), _style: 'width:5%;padding:0px'},
        {key: 'price_bestankar', label: this.$t('bestankar'), _style: 'width:5%;padding:0px'},

      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 1,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',


      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      // total_price: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      master_id: 0,
      document_result_price: [],

    }
  }, mounted() {
this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    this.get_product_units();


    bus.$on('delete_confirm_factor'+this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {

  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    // 'product_items': function () {
    //   this.total_price = 0;
    //
    //   var unit_value = 1;
    //   this.total_price = 0;
    //   this.product_items.forEach((val) => {
    //     this.unit_items.forEach((val_unit) => {
    //       if (val_unit.id == val.productUnitId) {
    //         unit_value = val_unit.value;
    //       }
    //
    //     });
    //     val.total_price = (Math.abs(val.qty) * val.price * unit_value);
    //     this.total_price += (Math.abs(val.qty) * val.price * unit_value);
    //
    //   });
    //   this.total_price = this.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // },
    'selectedType': function () {
      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {
    finalize() {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          self.get_document_master("print");

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;
          self.get_document_master();


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here
      this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master(print) {
      var self = this;


      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person = content_data.data.partyName;
          self.document_person_id = content_data.data.partyId;
          self.date = content_data.data.docDate;
          self.selected_place = content_data.data.placeName;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.doc_id_no = content_data.data.masterCode;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;
          // if (self.selectedType == 1) {
          //
          //   self.selectedTypeLabel = self.$t('components.seller');
          //   self.selectedTypeLabelRevert = self.$t('components.buyer');
          //   self.selectedTypeQty = 1;
          //   self.selectedTypeTitle = self.$t('components.documentBuy');
          // }
          // if (self.selectedType == 3) {
          //   self.selectedTypeLabel = self.$t('components.buyer');
          //   self.selectedTypeLabelRevert = self.$t('components.seller');
          //   self.selectedTypeQty = -1;
          //   self.selectedTypeTitle = self.$t('components.documentSell');
          //
          // }
          // if (self.selectedType == 5) {
          //   self.selectedTypeLabel = self.$t('components.employee');
          //   self.selectedTypeLabelRevert = self.$t('components.company');
          //   self.selectedTypeQty = 1;
          //   self.selectedTypeTitle = self.$t('components.documentFirst');
          //
          // }
          self.get_document_details(print);
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_result(print_op) {
      var self = this;


      const formData = new FormData();

      var url = "GetFactorResultByMasterId";

      formData.append("Id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
         var total = 0;
          self.document_result_price = [];
          content_data.data.factorResults.forEach((val) => {

            self.document_result_price.push(val);
            total+=parseInt(val.resultPrice.replace(/,/g,""));

          });
          content_data.data.factorCosts.forEach((val) => {

            self.document_result_price.push(val);
            total+=parseInt(val.resultPrice.replace(/,/g,""));
          });
          var obj = {currencyTitle: null, resultTitle:self.$t('factorTotalPrice'), resultPrice: self.get_currency(total)}
          self.document_result_price.push(obj);

          self.get_user_data();
if(print_op!=null){
  self.print();
}
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details(print) {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.product_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });
          self.get_document_result(print);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor'+this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {
        //
        var person  = res.data.data.person;
        self.document_person = person.personName +" "+ person.surName +" "+ person.mobileNo
        // self.document_person_remain_amount = res.data.data.mande;
        var tota_price = self.document_result_price[self.document_result_price.length-1].resultPrice;
        tota_price = tota_price.replaceAll(",","");

        // var  obj = {resultTitle: "مانده از قبل", resultPrice: res.data.data.mande.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")};
      tota_price =   parseInt(res.data.data.mande)+parseInt(tota_price)

        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };
        // self.document_result_price.push(obj)


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        this.$router.go(-1)

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    }

  }
}

</script>
